/* eslint-disable import/no-anonymous-default-export */

// this gets added to the reflection chunk in envmap_physical_pars_fragment.glsl.js
// variables that come from the parent file:

// approach like this?
// calculate perfect anisotropic reflection, then use mix to blend it with regular roughness?

export default /* glsl */`

    // figure out the reflection point
  vec3 adjustmentScale = 1.0 / boxProjectionSize;
  queryReflectVec = queryReflectVec * adjustmentScale;
  float anisotropyMipLevel = specularMIPLevel * 0.7;

  vec4 regularRoughnessReflection = textureCubeLodEXT( envMap, queryReflectVec, specularMIPLevel );
  const int samples = 16;
  float samplesFloat = float(samples);
  vec3 worldNormal = inverseTransformDirection( normalize( vNormal ), viewMatrix );
  vec3 worldTangent = inverseTransformDirection( normalize( vAnisotropicTangent ), viewMatrix );
  vec3 worldBitangent = cross(worldNormal, worldTangent);

  vec3 anisotropyDirection;
  vec3 anisotropyCrossDirection;

  if (tpmData.tilt){
    anisotropyDirection = worldBitangent;
    anisotropyCrossDirection = worldTangent;
  } else {
    anisotropyDirection = worldTangent;
    anisotropyCrossDirection = worldBitangent;
  }

  //anisotropyDirection = vec3(1.0, 0.0, 0.0);
  vec3 accumulator = vec3(0.0);
  vec3 anisotropyVector;
  float anisotropyPhase = 0.0;
  vec3 forwardVector;
  vec3 backwardVector;

  
  vec4 ormSample = textureCubeLodEXT( ormCubemap, queryReflectVec, specularMIPLevel);

  //accumulator += baseSample.xyz / samplesFloat;

  for (int i = 1; i <= samples; i++){
    float iFloat = float(i);
    anisotropyPhase = iFloat / samplesFloat;
    anisotropyVector = anisotropyDirection * (anisotropyPhase * anisotropyStrength );
    anisotropyVector = mix(anisotropyVector, vec3(0.0), (1.0 - roughness));
    //anisotropyVector = normalize(anisotropyVector);

    forwardVector = parallaxCorrectedNormal( normalize(reflectVec + anisotropyVector), boxProjectionSize, boxProjectionPosition, vWorldPosition) * adjustmentScale;
    backwardVector = parallaxCorrectedNormal( normalize(reflectVec - anisotropyVector), boxProjectionSize, boxProjectionPosition, vWorldPosition) * adjustmentScale;

    vec4 forwardSample = textureCubeLodEXT( envMap, forwardVector, anisotropyMipLevel );
    vec4 backwardSample = textureCubeLodEXT( envMap, backwardVector, anisotropyMipLevel );

    float fade = (1.0 - anisotropyPhase) / samplesFloat;

    //accumulator += forwardSample * fade;
    //accumulator += backwardSample * fade;
    accumulator += forwardSample.xyz;
    accumulator += backwardSample.xyz;
  }

  accumulator /= samplesFloat * 2.0;
  vec3 finalMix = mix(accumulator.xyz, regularRoughnessReflection.xyz, 0.0);
  //vec3 finalMix = accumulator;
  //finalMix = arbitraryVectorTangent.xyzz;
  //finalMix = st1.xyxx;
  // finalMix = anisotropyDirection;
  // dunno why this blew out
  envMapColor = vec4(finalMix, 1.0) * mix(1.0 - ormSample.b, 1.0, magic3);
`;